__turbopack_context__.v({
  "applied": "O0hOoq_applied",
  "apply": "O0hOoq_apply",
  "apply-btn": "O0hOoq_apply-btn",
});
